module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("in4bH"))).then(() => parcelRequire('9Lwss'));